<template>
  <div id="top" class="app-container" uk-height-viewport="expand: true">
    <div class="uk-width-1-1" uk-grid>
      <div class="uk-width-1-4 uk-visible@m nav-bar-padding">
        <filters></filters>
      </div>
      <div class="top-margin mobile-margin uk-width-3-4@m uk-width-1-1@s">
        <div class="uk-visible@m nav-bar-padding">
          <div class="uk-align-left">
            <div class="uk-display-inline-block">
              <div class="disabled padding" v-if="(this.searchResults.totalResults === 0) || selectedAuthor">
                <span
                  class="uk-text-bold sort-text default-cursor">{{$t('general.sortBy')}}:&nbsp;</span>
                <span>
                  <span>{{selectedSorting}}</span>
                  <span uk-icon="icon: triangle-down; ratio: 1.25"></span>
                </span>
              </div>
              <div v-else class="padding">
                <span
                  class="uk-text-bold sort-text default-cursor">{{$t('general.sortBy')}}:&nbsp;</span>
                <span class="selected-sort-text"
                      @mouseover="toggleHover(true)"
                      @mouseleave="toggleHover(false)">
                        <span v-if="highlightSortOption">
                          <span class="selected">{{selectedSorting}}</span>
                          <span class="sort-triangle" uk-icon="icon: triangle-up; ratio: 1.25"></span>
                        </span>
                        <span v-else>
                          <span :class="{'selected': sortHover}">{{selectedSorting}}</span>
                          <span class="sort-triangle" uk-icon="icon: triangle-down; ratio: 1.25"></span>
                        </span>
                    </span>
              </div>
              <div id="sorting-dropdown" uk-dropdown="mode: click; delay-hide:0"
                   @hide="toggleHighlightSortOption(false)"
                   @show="toggleHighlightSortOption(true)">
                <div :value="option.id" v-for="option in renderSortDropdown">
                  <li v-if="sort === option.id" class="sorting-selection-selected-text">{{option.title}}</li>
                  <li @click="setSelectedSort(option.id)" class="sorting-selection-default-text" v-else>
                    {{option.title}}
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-align-right pagination-padding-bottom">
            <pagination
              :currentPage="pageNumber"
              :nextEnabled="nextAvailable"
              @fetchNextBatch="fetchNextResults"
              @fetchPreviousBatch="fetchPreviousResults">
            </pagination>
          </div>
        </div>
        <div v-if="searchResults.loading">
          <div class="uk-hidden@m uk-position-center">
            <spinner></spinner>
          </div>
          <div class="uk-visible@m">
            <div class="spinner-top-padding uk-flex uk-flex-center">
              <spinner></spinner>
            </div>
          </div>
        </div>
        <div v-else-if="searchResults.error.status || hasError()">
          <search-error class="error-margin" :searchTerm="searchText" :error="searchResults.error"
                        :noResult="hasError()" id="searchError"></search-error>
        </div>
        <div class="result-section" v-else>
          <div class="search-result-item" v-for="item in results" :key="item.contentId">
            <search-result-item class="uk-visible@s" :item="item" id="resultItem"></search-result-item>
            <search-result-item-mobile class="uk-hidden@s" :item="item"
                                       id="resultItemMobile"></search-result-item-mobile>
          </div>
          <div class="uk-width-1-1">
            <div class="uk-flex uk-flex-center">
              <pagination v-if="!(this.searchResults.totalResults === 0)"
                          :currentPage="pageNumber"
                          :nextEnabled="nextAvailable"
                          @fetchNextBatch="fetchNextResults"
                          @fetchPreviousBatch="fetchPreviousResults">
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import Filters from './filters/filters'
  import SearchResultItem from './search-results/desktop/search-result-item'
  import Pagination from './pagination'
  import SearchResultItemMobile from './search-results/mobile/search-result-item-mobile'
  import Spinner from '../ui-components/spinner/spinner'
  import SearchError from './search-error'
  import selectedFilters from '../../utils/selected-filters-util.js'
  import * as sorting from '../../enums/sorting.js'
  import * as categories from '../../enums/categories'
  import * as grades from '../../enums/grades'
  import * as subjects from '../../enums/subjects'
  import * as contentType from '../../enums/content-type'
  import enviro from '../../plugins/environment/index'
  import * as event from '../../enums/mixpanel-event'
  import uikit from 'uikit'
  import mixpanel from '../../services/mixpanel'
  import subjectResolver from '../../utils/subject-resolver-util'
  import userLanguagesUtil from '../../utils/user-languages-util'

  export default {
    name: 'DiscoveredContent',
    components: {
      SearchError,
      SearchResultItemMobile,
      Filters,
      Spinner,
      SearchResultItem,
      Pagination
    },
    data() {
      return {
        displayedContent: [],
        error: null,
        noResultError: false,
        nextEnabled: false,
        highlightSortOption: false,
        sortHover: false,
        selectingFilters: false,
        triggerFilteredSearch: true,
        timer: null,
        trySomethingNewId: [],
        manageYourClassroomId: [],
        studentActivitiesId: [],
        featuredContentId: [],
        standardsContentId: [],
        topPrimaryId: [],
        topSecondaryId: [],
        featuredPublisherContentId: []
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['searchResults', 'sorting', 'pagination', 'filters', 'searchTerm', 'author', 'keyword', 'selectedCategory']),
      sort: {
        get() {
          return this.sorting.items.find(f => f.selected).id
        },
        set(newValue) {
          this.sorting.items.map(f => {
            f.selected = f.id === newValue
          })
          this.updateSorting(this.sorting)
        }
      },
      renderSortDropdown() {
        return this.sorting.items.filter(f => f.id !== sorting.SORT_BY_FEATURED)
      },
      selectedSorting() {
        return this.sorting.items.find(f => f.selected).title
      },
      pageNumber() {
        return this.pagination.pageNumber
      },
      results() {
        return this.searchResults.items[this.pagination.pageNumber - 1]
      },
      nextAvailable() {
        return this.pagination.pageNumber < this.searchResults.items.length
      },
      selectedFilters() {
        return this.filters
      },
      selectedAuthor() {
        return this.author
      },
      selectedKeyword() {
        return this.keyword
      },
      isGermanLocale() {
        return this.$i18n.locale === 'de' && this.$feature('german-regionalised-categories').enabled
      },
      isNorwegianLocale() {
        return this.$i18n.locale === 'nb' && this.$feature('norwegian-regionalised-categories').enabled
      }
    },
    methods: {
      ...mapMutations(['updateSorting', 'updateSearchText', 'setSearchResults', 'updatePaginationPage', 'updateAuthorFilter']),
      ...mapActions(['fetchSearchResults', 'cleanSetSearchCriteria', 'setDefaultSorting', 'setDefaultAuthorFilter', 'setDefaultKeywordFilter', 'setDefaultFilters']),
      toggleHighlightSortOption(val) {
        this.highlightSortOption = val
      },
      toggleHover(val) {
        this.sortHover = val
      },
      setSelectedSort(option) {
        uikit.dropdown('#sorting-dropdown').hide()
        this.sort = option
        this.toggleHighlightSortOption(false)
        mixpanel.track(event.UPDATED_SORTING, {sortBy: this.selectedSorting})
      },
      hasError() {
        if (this.searchResults.totalResults === 0 && !this.searchResults.error.status) {
          return true
        } else {
          return false
        }
      },
      search(value) {
        this.cleanSetSearchCriteria(value)
        this.fetchResults(null, this.pagination.pageSize + 1, this.pagination.pageNumber, this.searchResults, false)
      },
      fetchNextResults() {
        if (this.searchResults.items.length - 1 > this.pagination.pageNumber ||
            (this.searchResults.items.length > this.pagination.pageNumber && !this.searchResults.nextPageToken)) {
          this.scrollToPosition()
          let page = this.pagination.pageNumber
          page++
          this.updatePaginationPage(page)
        } else {
          this.fetchResults(this.searchResults.nextPageToken, this.pagination.pageSize, this.pagination.pageNumber, this.searchResults, false)
          this.scrollToPosition()
        }
      },
      fetchPreviousResults() {
        this.scrollToPosition(window.pageYOffset)
        let page = this.pagination.pageNumber
        page--
        this.updatePaginationPage(page)
      },
      fetchResults(nextPageToken, limit, page, currentResults, cleanSearch) {
        let sortBy = null
        let category = null
        if (this.selectedCategory) {
          switch (this.selectedCategory) {
            case categories.STUDENT_ACTIVITIES:
              category = this.studentActivitiesId
              break
            case categories.MANAGE_YOUR_CLASSROOM:
              category = this.manageYourClassroomId
              break
            case categories.TRY_SOMETHING_NEW:
              category = this.trySomethingNewId
              break
            case categories.FEATURED_CONTENT:
              category = this.featuredContentId
              break
            case categories.STANDARDS_CONTENT:
              category = this.standardsContentId
              break
            case categories.TOP_PRIMARY:
              category = this.topPrimaryId
              break
            case categories.TOP_SECONDARY:
              category = this.topSecondaryId
              break
            case categories.FEATURED_PUBLISHER_CONTENT:
              category = this.featuredPublisherContentId
              break
          }
          if (this.selectedSorting !== sorting.MostPopular) {
            sortBy = sorting.SORT_BY_FEATURED
          }
        }
        if (this.selectedSorting === sorting.MostPopular) {
          sortBy = sorting.SORT_BY_POPULARITY
        }
        if (cleanSearch) {
          this.cleanSetSearchCriteria(this.searchTerm)
        }
        this.fetchSearchResults(
          {
            nextPageToken: nextPageToken,
            limit: limit,
            currentResults: currentResults,
            currentPage: page,
            grades: this.resolveFilter(grades.GRADES_TITLE),
            subjects: subjectResolver.resolveIds(this.resolveFilter(subjects.SUBJECTS_TITLE)),
            componentTypes: this.resolveFilter(contentType.CONTENT_TYPE_TITLE),
            countries: this.resolveFilter('Location'),
            langPrefer: userLanguagesUtil.resolve()[0],
            author: this.selectedAuthor,
            sortBy: sortBy,
            keyword: this.selectedKeyword,
            labels: category,
            standardSets: this.resolveFilter('Standards'),
            standardStrands: this.resolveFilter('Strands')
          }
        )
      },
      handleTimer(timerOption) {
        if (timerOption === 'start') {
          this.timer = setTimeout(() => {
            this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
          }, 1500)
        } else {
          window.clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
          }, 1500)
        }
      },
      resolveFilter(filterGroup) {
        let filters = selectedFilters.resolve(this.filters)
        if (filters.find(o => o.filterGroup === filterGroup).selectedFilters.length) {
          return filters.find(o => o.filterGroup === filterGroup).selectedFilters
        }
      },
      scrollToPosition(position) {
        if (position) {
          window.scrollTo(0, position)
        } else {
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }
      },
      setDevEnviroLabels () {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.DEV_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.DEV_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.DEV_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.DEV_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.DEV_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.DEV_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.DEV_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.DEV_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.DEV_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.DEV_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.DEV_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.DEV_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.DEV_STANDARDS_CONTENT_ID]
        }
      },
      setPreprodEnviroLabels() {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.PREPROD_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.PREPROD_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PREPROD_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PREPROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.PREPROD_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.PREPROD_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PREPROD_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PREPROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.PREPROD_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.PREPROD_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.PREPROD_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.PREPROD_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.PREPROD_STANDARDS_CONTENT_ID]
        }
      },
      setProdEnviroLabels() {
        if (this.isGermanLocale) {
          this.featuredContentId = [categories.PROD_GERMAN_FEATURED_ID]
          this.topPrimaryId = [categories.PROD_GERMAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PROD_GERMAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else if (this.isNorwegianLocale) {
          this.featuredContentId = [categories.PROD_NORWEGIAN_FEATURED_ID]
          this.topPrimaryId = [categories.PROD_NORWEGIAN_TOP_PRIMARY_ID]
          this.topSecondaryId = [categories.PROD_NORWEGIAN_TOP_SECONDARY_ID]
          this.featuredPublisherContentId = [categories.PROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID]
        } else {
          this.studentActivitiesId = [categories.PROD_STUDENT_ACTIVITIES_ID]
          this.manageYourClassroomId = [categories.PROD_MANAGE_YOUR_CLASSROOM_ID]
          this.trySomethingNewId = [categories.PROD_TRY_SOMETHING_NEW_ID]
          this.featuredContentId = [categories.PROD_FEATURED_CONTENT_ID]
          this.standardsContentId = [categories.PROD_STANDARDS_CONTENT_ID]
        }
      },
      setEnviroLabels () {
        if (enviro.isDev()) {
          this.setDevEnviroLabels()
        } else if (enviro.isUat() || enviro.isPreprod()) {
          this.setPreprodEnviroLabels()
        } else if (enviro.isProd()) {
          this.setProdEnviroLabels()
        }
      }
    },
    watch: {
      searchText(value) {
      },
      '$route'(to, from) {
        try {
          this.triggerFilteredSearch = false
          this.setDefaultFilters(this.filters)
          if (to.query.author) {
            this.updateAuthorFilter(to.query.author)
          } else {
            this.setDefaultAuthorFilter()
          }
          this.setDefaultKeywordFilter()
          setTimeout(() => {
            this.triggerFilteredSearch = true
          }, 1000)
          this.search(to.query.searchText)
        } catch (err) {
          this.triggerFilteredSearch = true
        }
      },
      selectedFilters() {
        if (this.triggerFilteredSearch) {
          if (!this.timer) {
            this.handleTimer('start')
          } else {
            this.handleTimer('reset')
          }
        }
      },
      selectedAuthor() {
        if (this.triggerFilteredSearch) {
          this.setDefaultSorting(this.sorting.items)
          this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
        }
      },
      selectedKeyword() {
        if (this.triggerFilteredSearch) {
          this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
        }
      },
      selectedSorting() {
        if (this.triggerFilteredSearch) {
          this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
        }
      },
      selectedCategory() {
        if (this.triggerFilteredSearch) {
          this.fetchResults(null, this.pagination.pageSize + 1, 0, null, true)
        }
      }
    },
    mounted() {
      this.triggerFilteredSearch = false
      this.scrollToPosition()
      this.setEnviroLabels()
      this.triggerFilteredSearch = false
      if (this.$route.query.author) {
        this.updateAuthorFilter(this.$route.query.author)
      }
      if (!this.searchResults.items.length) {
        this.search(this.$route.query.searchText)
      } else if (this.$route.query.searchText) {
        this.setSearchCriteria({searchText: this.$route.query.searchText})
      }
      mixpanel.track(event.VIEWING_SEARCH_RESULTS)
      setTimeout(() => {
        this.triggerFilteredSearch = true
      }, 2000)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../src/styles/breakpoints';
  @import '../../../src/styles/colours';

  .selected-sort-text {
    color: $font-color;
    font-size: 16px;
  }

  .error-margin {
    margin-top: 40px;
  }

  .sort-text {
    font-size: 16px;
  }

  .pagination-padding {
    padding-right: 30px;
  }

  .sorting-selection-default-text {
    font-size: 20px;
    padding: 5px;
    cursor: pointer;
    color: $font-color;

    &:hover {
      color: $light-blue;
    }
  }

  .sorting-selection-selected-text {
    font-size: 20px;
    color: $light-blue;
    padding: 5px;
  }

  .top-padding {
    padding-top: 9px;
  }

  .uk-align {
    margin-bottom: 10px;
  }

  .btn-dropdown {
    border: 0;
    background-color: transparent;
  }

  .nav-bar-padding {
    padding-top: 56px;
  }

  hr {
    background: $light-blue;
    width: 65%;
    height: 5px;
    text-align: right;
    margin: 0 0 0 auto;
  }

  .uk-button {
    padding-left: 0;
    padding-right: 0;
  }

  .padding {
    padding-top: 8px;
    padding-left: 0;
  }

  .pagination-padding-bottom {
    padding-bottom: 8px
  }

  .sorting-hover {
    &:hover {
      color: $light-blue;
    }
  }

  .selected {
    color: $light-blue;
  }

  .disabled {
    color: $light-grey;
    font-size: 16px;
  }

  .sort-triangle {
    color: $light-blue;
    cursor: pointer;
  }

  .default-cursor {
    cursor: default;
  }

  .uk-dropdown {
    padding: 10px 0 10px 10px;
  }

  .uk-align-left {
    margin-bottom: 10px;
  }

  .uk-align-right {
    margin-bottom: 10px;
  }

  .center-spinner {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .spinner-top-padding {
    padding-top: 400px;
  }

  .top-margin {
    margin-top: 115px;
  }

  .result-section {
    margin-top: 56px
  }

  @media screen and (min-width: $breakpoint-medium) {
    .pagination-padding {
      padding-right: 40px;
    }

    .top-padding {
      padding-top: 11px;
    }

    .top-margin {
      margin-top: 30px;
    }

  }

  @media screen and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
    }
    .result-section {
      margin-top: 0;
    }
  }

  @media screen and (max-width: $breakpoint-medium - 1) {
    .mobile-margin {
      margin-left: 4%;
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .search-result-item {
      padding-left: 5px;
      padding-right: 5px;
      width: 105.5%;
    }
    .mobile-margin {
      margin-left: 0;
      margin-right: 1%;
    }
    .error-margin {
      margin-left: 7.5%;
    }
  }
</style>
